export default __webpack_public_path__ + "static/media/ieee yp.38235f6b.png";